import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { Card } from "../redesign/store-settings/primitives";
import { IntegrationsGrid } from "./IntegrationsGrid";
import { PaymentGatewayTile } from "./PaymentGatewayTile";
import { PAYMENT_GATEWAYS } from "./paymentGatewayDescriptors";

// Online-payment gateways block for the seller payment settings — same Card
// shell (title + subtitle + tile grid) as the shipping integrations section.
export function PaymentGatewaysSection({ storeSlug }: { storeSlug: string }) {
  const t = useTranslations();
  return (
    <Card
      title={t(keys.paymentGateway.sectionTitle)}
      desc={t(keys.paymentGateway.sectionSubtitle)}
    >
      <IntegrationsGrid>
        {PAYMENT_GATEWAYS.map((descriptor) => (
          <PaymentGatewayTile
            key={descriptor.provider}
            storeSlug={storeSlug}
            descriptor={descriptor}
          />
        ))}
      </IntegrationsGrid>
    </Card>
  );
}
